/**
 * The requisition status vocabulary, in a module that imports nothing.
 *
 * Same bundle decision as `offer-vocabulary.ts` and `referral-vocabulary.ts`:
 * `router.tsx` imports every route's `validateSearch` schema EAGERLY, so
 * whatever a search module reaches for lands in the initial chunk.
 * `recruitment.route.search.ts` validates the requisitions tab's status filter
 * against this tuple, and taking it from `schemas/recruitment.schema.ts` would
 * drag every staffing plan, requisition and opening schema in with it.
 *
 * `schemas/recruitment.schema.ts` still declares its own copy of this tuple
 * for the wire parser. Folding that one onto this module is the obvious
 * follow-up, and belongs to whoever owns that file next.
 */

export const REQUISITION_STATUS_NAMES = [
  "pending",
  "open_and_approved",
  "rejected",
  "filled",
  "on_hold",
  "cancelled",
] as const;

export type RequisitionStatusName = (typeof REQUISITION_STATUS_NAMES)[number];
